import { useGetSportsQuery } from 'app/imports/App.hooks'
import { UISelect } from 'features/UI'
import { useAppDispatch } from 'hooks'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { OnChangeValue } from 'react-select'
import { Sport } from 'types'
import { getQueryParams } from 'utils'
import { setFilterSport } from '../../state/Filters.reducer'
import { getSelectedSport } from '../../state/Filters.selectors'
import { FiltersLeagueSwitch } from '../FiltersLeagueSwitch/FiltersLeagueSwitch'
import * as Styled from './Filters.styled'

export function Filters() {
  const dispatch = useAppDispatch()
  const { state, district } = getQueryParams()

  const { data: sports } = useGetSportsQuery({
    stateId: state,
    districtId: district,
  })

  const selectedSport = useSelector(getSelectedSport)

  const sportItems = useMemo(() => {
    if (!sports) {
      return []
    }

    return sports.items.filter((sport) => !sport.isParent)
  }, [sports])

  const handleSportChange = (sport: OnChangeValue<Sport, false>) => {
    dispatch(setFilterSport(sport))
  }

  if (!sports) {
    return null
  }

  return (
    <Styled.FiltersContainer>
      <UISelect<Sport, false>
        options={sportItems}
        value={selectedSport}
        onChange={handleSportChange}
        isMulti={false}
        getOptionLabel={(option) => option.name}
        getOptionValue={(option) => option.id}
        placeholder="Search Sport"
      />

      <FiltersLeagueSwitch />
    </Styled.FiltersContainer>
  )
}
